import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=6ba0d2fc&scoped=true"
import script from "./channels.vue?vue&type=script&lang=js"
export * from "./channels.vue?vue&type=script&lang=js"
import style0 from "./channels.vue?vue&type=style&index=0&id=6ba0d2fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0d2fc",
  null
  
)

export default component.exports